"use strict";

class UsageInstructionDialogCtrl {


    constructor($scope, $mdDialog, widgetInstructions, widgetTitle) {

        //Attach dependicies to class root
        this.$mdDialog = $mdDialog;

        //Ugly work around OK button!
        $scope.ok = () => {
            this.ok();
        };

        $scope.instructions = widgetInstructions;
        $scope.title = widgetTitle;
    }

    /*
     * managed OK event from confirm dailog
     */
    ok() {
        this.$mdDialog.hide();
    }
}


/*
 * Inject dependicies
 */
UsageInstructionDialogCtrl.$inject = ['$scope', '$mdDialog', 'widgetInstructions', 'widgetTitle'];


/*
 * Browsify connection: execute controller
 */
module.exports = UsageInstructionDialogCtrl;
